import React from 'react';
import { Row } from 'react-bootstrap';
import {
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  CustomSelectComponent,
  buildWhereForDates,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { useRootStore } from 'store';
import {
  FieldSelectContributionPeriod,
  FieldSelectContributionPeriodGroups,
  FieldSelectContributionSeries,
  FieldSelectContributionState,
} from '../../components';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ '$contributor.name$': likeObj }],
      };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'declarationDate'),
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.year !== undefined && values.year !== null && values.year !== '') {
      where = { ...where, year: values.year };
    }

    if (values.periodId !== undefined && values.periodId !== null && values.periodId !== '') {
      where = { ...where, periodId: values.periodId };
    }
    if (values.seriesId !== undefined && values.seriesId !== null && values.seriesId !== '') {
      where = { ...where, seriesId: values.seriesId };
    }

    if (values.statusId !== undefined && values.statusId !== null && values.statusId !== '') {
      where = { ...where, statusId: values.statusId };
    }

    if (
      values.contributionPeriodGroupId !== undefined &&
      values.contributionPeriodGroupId !== null &&
      values.contributionPeriodGroupId !== ''
    ) {
      where = {
        ...where,
        '$contributionperiod.contributionPeriodGroupId$': values.contributionPeriodGroupId,
      };
    }

    if (values.isInvoiced !== undefined && values.isInvoiced !== null && values.isInvoiced !== '') {
      where = { ...where, isInvoiced: values.isInvoiced };
    }
    if (
      values.releaseToErp !== undefined &&
      values.releaseToErp !== null &&
      values.releaseToErp !== ''
    ) {
      where = { ...where, releaseToErp: values.releaseToErp };
    }
    if (values.isCanceled !== undefined && values.isCanceled !== null && values.isCanceled !== '') {
      where = { ...where, isCanceled: values.isCanceled };
    }
    if (values.contributorId) where = { ...where, contributorId: values.contributorId };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  console.log('$$$$ contribitions-filters-initialvalues', initialValues);
  //
  const { t } = useTranslation();
  const { appStore } = useRootStore();
  //
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    year: initialValues?.year ?? null,
    periodId: initialValues?.periodId ?? null,
    statusId: initialValues?.statusId ?? null,
    seriesId: initialValues?.seriesId ?? undefined,
    contributionPeriodGroupId: initialValues?.contributionPeriodGroupId ?? null,
    isInvoiced: initialValues?.isInvoiced ?? null,
    releaseToErp: initialValues?.releaseToErp ?? null,
    isCanceled: initialValues?.isCanceled ?? null,
    contributorId: initialValues?.contributorId ?? undefined,
  };

  //
  const options = [
    { value: true, label: t('ΝΑΙ') },
    { value: false, label: t('ΟΧΙ') },
  ];

  const yearOptions = () => {
    const firstYear = 2024;
    const newDate = new Date();
    const currentYear = newDate.getFullYear() + 2;
    const years = currentYear - firstYear;
    const options = [{ value: currentYear.toString(), label: currentYear.toString() }];

    let nextYear;
    for (let i = years - 1; i > 0; i--) {
      nextYear = firstYear + i;
      options.push({ value: nextYear.toString(), label: nextYear.toString() });
    }
    if (firstYear !== currentYear) {
      options.push({ value: firstYear.toString(), label: firstYear.toString() });
    }
    console.log('number of years difference is ', years);
    return options;
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        {appStore.isPlatformOwner && !isGridInForm && (
          <FieldInput
            as={FormCol}
            name="searchText"
            label={t('Αναζήτηση (Υπόχρεος)')}
            type="search"
          />
        )}
        <Field
          name={'year'}
          title={t('Έτος')}
          component={CustomSelectComponent}
          options={yearOptions()}
        />
        <FieldSelectContributionPeriod as={FormCol}></FieldSelectContributionPeriod>
        <FieldSelectContributionState as={FormCol}></FieldSelectContributionState>
        <FieldSelectContributionSeries as={FormCol} />
        {appStore.isPlatformOwner && (
          <FieldSelectContributionPeriodGroups
            as={FormCol}
            name="contributionPeriodGroupId"
          ></FieldSelectContributionPeriodGroups>
        )}
        <FieldDateRanger
          as={FormCol}
          label={t('Ημ/νία Υποβολής από')}
          label2={t('Έως')}
          name="startDate"
          name2="endDate"
        />
        {appStore.isPlatformOwner && (
          <>
            <Field
              name={'isInvoiced'}
              title={t('Τιμολογημένη')}
              component={CustomSelectComponent}
              options={options}
            />
            <Field
              name={'isCanceled'}
              title={t('Ακυρωμένη')}
              component={CustomSelectComponent}
              options={options}
            />
          </>
        )}
        {!appStore.isPlatformOwner && (
          <Field
            name={'isCanceled'}
            title={t('Ακυρωμένη')}
            component={CustomSelectComponent}
            options={options}
            as={FormCol}
          />
        )}
      </Row>
    </FormFilterCard>
  );
};

